import {
  classPerformanceResponseSchema,
  type ClassPerformanceResponse,
} from '@/features/benchmarking/schemas/benchmarkingClassPerformance';
import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';

export type GetBenchmarkingClassPerformanceParams = { escolaId: number; anoEscolarId?: number };

export const getBenchmarkingClassPerformance = httpGetAdapter<
  ClassPerformanceResponse,
  GetBenchmarkingClassPerformanceParams
>({
  url: (params) => `/v3/microdados/escola/${params.escolaId}/desempenho-turmas`,
  schema: classPerformanceResponseSchema,
  mapParams: ({ escolaId: _escolaId, ...rest }) => rest,
});
